import { useEffect, useState } from "react";

// Contexte transmis à EVA (chat de la plateforme) : la fiche ouverte à
// l'écran. Un écran le pose à l'ouverture d'une fiche et le retire à la
// fermeture ; EvaChat l'écoute pour que « ce client » soit compris sans
// recherche. Le serveur revérifie que l'utilisateur a le droit de voir la
// fiche avant de la décrire à EVA.

let contexte = {};
const abonnes = new Set();

export function setEvaContexte(valeur) {
  contexte = { ...(valeur || {}) };
  abonnes.forEach((f) => f(contexte));
}

// Retire le contexte seulement s'il appartient encore à l'appelant (une
// fiche fermée ne doit pas effacer celle qui vient de s'ouvrir).
export function clearEvaContexte(clientId) {
  if (clientId === undefined || contexte.clientId === clientId) setEvaContexte({});
}

export function useEvaContexte() {
  const [valeur, setValeur] = useState(contexte);
  useEffect(() => {
    abonnes.add(setValeur);
    return () => abonnes.delete(setValeur);
  }, []);
  return valeur;
}
